import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 md:mb-16">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              最新资讯
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              热门文章推荐
            </h2>
          </div>
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 mt-4 sm:mt-0 px-5 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap text-primary-600 hover:text-primary-700 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {latestArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                    {article.categoryLabel}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    阅读更多
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}